import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { useAuthentication } from '@/hooks/auth/useAuthentication';
import { RfpProfessionalOne } from '@/pages/rfp/professional/RfpProfessionalOne/RfpProfessionalOne';
/**
 * コンサルタント：案件詳細ページの認証制御を行うコンポーネント
 * @constructor
 */
export const RfpProfessionalOneAuth = () => {
    // 認証周りの判定取得
    const { message: authRedirectMessage, profile, redirectTo: authRedirectTo, } = useAuthentication({
        // PROFFITの利用権限がある
        isCanUseProffit: true,
        // 管理者ユーザーであれば常に表示を許可する
        isForceAdmin: true,
        // 仮登録のコンサルタントでない
        isPreProfessional: false,
    });
    // リダイレクト: ユーザー認証
    if (authRedirectTo || !profile) {
        return _jsx(CustomRedirect, { message: authRedirectMessage, to: authRedirectTo });
    }
    return _jsx(RfpProfessionalOne, { profile: profile });
};
